<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>AIC ONE - Sign In</title>
</head>

<body class="background-body">
    <div class="container align-items-center d-flex">
        <div class="logo-section">
            <img :src="styleConfig.reset_logo" alt="aicone Logo" class="logo">
            <div class="user-count d-none">
                <div class="user-dots d-flex">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
                <span>3k+ people joined us, now it's your turn</span>
            </div>
        </div>

        <div class="sign-in-form">
            <div class="mb-1 text-start">
                <h2 class="text-black fw-bold">Register</h2>
            </div>
            <form @submit.prevent="submit_form">
                <div class="  mb-4 ">
                    <div class="d-flex gap-5 mt-3">
                        <label v-for="client in client_types" :key="client.id" class="form-check-label">
                            <input type="radio" :value="client.id" v-model="form.client_type"
                                class="form-check-input me-1" />
                            {{ client.name }}
                        </label>
                    </div>
                </div>
                <!-- Name -->
                <div class="form-floating-custom">
                    <input type="text" id="name" class="form-input" placeholder=" " v-model="form.name" />
                    <label class="form-label" for="name">Name</label>
                </div>

                <!-- Surname -->
                <div class="form-floating-custom">
                    <input type="text" id="surname" class="form-input" placeholder=" " v-model="form.surname" />
                    <label class="form-label" for="surname">Surname</label>
                </div>

                <!-- Email -->
                <div class="form-floating-custom">
                    <input type="email" id="email" class="form-input" placeholder=" " v-model="form.email" />
                    <label class="form-label" for="email">Email Address</label>
                </div>

                <!-- Password -->
                <div class="form-floating-custom password-group">
                    <input :type="password_visible ? 'text' : 'password'" id="password" class="form-input"
                        placeholder=" " v-model="form.password" @focus="password_focused = true"
                        @blur="password_focused = false" />
                    <label class="form-label" for="password">Password</label>
                    <button type="button" class="password-toggle" @click="password_visibility()">
                        <i :class="password_visible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                </div>

                <!-- Confirm Password -->
                <div class="form-floating-custom password-group">
                    <input :type="confirm_password_visible ? 'text' : 'password'" id="confirm_password"
                        class="form-input" placeholder=" " v-model="form.confirm_password" />
                    <label class="form-label" for="confirm-password">Confirm Password</label>
                    <button type="button" class="password-toggle" @click="confirm_password_visibility()">
                        <i :class="confirm_password_visible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                </div>

                <div v-if="password_focused" class="password-criteria mt-1 mb-2 text-start small">
                    <div class="criteria-item">
                        <i :class="{ 'fa fa-check-circle text-success': meets_criteria.length, 'fa fa-check-circle': !meets_criteria.length }"
                            class="me-1"></i> At least 8 characters
                    </div>
                    <div class="criteria-item">
                        <i :class="{ 'fa fa-check-circle text-success': meets_criteria.lowercase, 'fa fa-check-circle': !meets_criteria.lowercase }"
                            class="me-1"></i> Lowercase letter
                    </div>
                    <div class="criteria-item">
                        <i :class="{ 'fa fa-check-circle text-success': meets_criteria.uppercase, 'fa fa-check-circle': !meets_criteria.uppercase }"
                            class="me-1"></i> Uppercase letter
                    </div>
                    <div class="criteria-item">
                        <i :class="{ 'fa fa-check-circle text-success': meets_criteria.special, 'fa fa-check-circle': !meets_criteria.special }"
                            class="me-1"></i> Special character
                    </div>
                </div>

                <!-- Submit Button -->
                <button type="submit" class="sign-up-btn" :disabled="loading">
                    <span v-if="!loading">Sign Up</span>
                    <span v-else>
                        <i class="bi bi-arrow-repeat spin"></i> Registering...
                    </span>
                </button>

                <!-- Already have account -->
                <div class="mt-4">
                    <span class=" text-decoration-none small">
                        Already Have an Account?
                        <a href="/" class="text-decoration-underline">Click Here</a>
                    </span>
                </div>
            </form>
        </div>
    </div>
</body>